module.exports = __webpack_public_path__ + "img/logo-copa-prosa.02987131.png";